export default __webpack_public_path__ + "static/chat-dark-1e77d4181f17fd7cb59ba23a0925fcbb2f5312095074741b3b1f90f000f00903.png";